import axios from "axios";
import store from "redux/Store";
import { pagingTotalRelation } from "redux/Types";
import { FilterOperatorTypes } from "util/table-view/TableTypes";
import { v4 as uuidv4 } from "uuid";
import { mltombfiltertypes, multiDepartmentMappingMltoMB, programmeAndFormType, standardProgrammeType } from "../Types";
var module = "/cueSheet";
export const actionTypes = {
  LOADING: "LOADING" + module,
  LOAD: "LOAD" + module,
  ERROR: "ERROR" + module,
  FOCUS_ITEM: "FOCUS_ITEM" + module,
  SELECT_ITEMS: "SELECT_ITEMS" + module,
  QUERY: "QUERY" + module,
  EDIT_ITEM: "EDIT_ITEM" + module,
  POSTING: "POSTING" + module,
  POST_OK: "POSTOK" + module,
  POST_ERROR: "POST_ERROR" + module,
  SET_CUESHEET: "SET_CUESHEET" + module,
  SET_SESSION: "SET_SESSION" + module,
  SET_LINK_CF: "SET_LINK_CF" + module,
  RESET_LINK_CF: "RESET_LINK_CF" + module,
  POST_LINK_ERROR: "POST_LINK_ERROR" + module,
};

export const editItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.EDIT_ITEM,
    payload: item,
  });
};
export const selectLinkCF = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_LINK_CF,
    payload: item,
  });
};
export const resetLinkCf = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_LINK_CF,
    payload: null,
  });
};
export const onLinkCf = (message) => (dispatch) => {
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });
};
export const onLinkCfSuccess = () => (dispatch) => {
  dispatch({
    type: actionTypes.POST_OK
  });
};
export const onLinkCfError = (message) => (dispatch) => {
  dispatch({
    type: actionTypes.POST_LINK_ERROR,
    message: message
  });
  setTimeout(() => {
    dispatch({
      type: actionTypes.POST_OK,
    });
  }, 3000);
};

export const postItem = (action, message, items, sessionid, done = null) => (dispatch) => {

  const tId = uuidv4();

  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  axios
    .post(`/cuesheet/${action}`, items, {
      headers: {
        tid: tId,
        sessionid: sessionid
      },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.POST_OK,
        payload: `${action === 'link' ? 'Link cue sheet' : action === 'unlink' ? 'Unlink cue sheet' : action} successful`,
      });

      if (done) done(res.data, null);
      //}
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data || { e: (err.message ? err.message : "Error in link or unlink. please retry") },
      });

      if (done) done(null, err);
    });
};
export const unlink = (action, message, cueSheetId, sessionid, cfId, done = null) => (dispatch) => {

  const tId = uuidv4();

  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  axios
    .delete(`/cuesheet/link/${cueSheetId}/${cfId}`, {
      headers: {
        tid: tId,
        sessionid: sessionid
      },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.POST_OK,
        payload: `Unlink cue sheet successful`,
      });

      if (done) done(res.data, null);
      //}
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data.e || { e: (err.message ? err.message : "Error in unlink. please retry") },
        message: err.response?.data.e || "Error in unlink. please retry",
      });

      if (done) done(null, err);
    });
};

export const setQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERY,
    payload: query,
  });

  if (done) done();
};

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};
const cfSearch = (query, history, sId, tId, cuesheet_header = null, done = null) => (dispatch) => {

  const {
    cueSheet: {
      session,
      cueSheet
    }
  } = store.getState();

  // =====
  if (!cuesheet_header) {
    cuesheet_header = cueSheet;
  }
  let newFilters = [...query.filters];
  if (session && session?.user_group === "BC" && session?.broadcaster_id === 8) {
    // query.filters = newFilters;
  }
  else if (session && session?.producer_id) {
    let filter = {
      operator: FilterOperatorTypes.equals,
      value: [session?.producer_id.toString()],
      field: "productionCompany",
    };
    newFilters.push(filter);
  }
  else if (session && (session?.input_group_id && session?.input_group_departments && session?.input_group_departments.length > 0)) {
    let mappedGroups = session.input_group_departments.map(d => {
      let groupTypeDep = multiDepartmentMappingMltoMB.filter(e => e.filterType == mltombfiltertypes.DEPARTMENT);
      let i = groupTypeDep.findIndex(l => l.mlDepartmentIds.some(k => k == d.input_group_department_id));
      if (i != -1) {
        return `${groupTypeDep[i].mbDepartmentId}`;
      }
      else {
        return `${d.input_group_department_id}`;
      }
    })
    const uniqueGroupIds = mappedGroups.filter((value, index, self) => self.indexOf(value) === index);
    let filter2 = {
      operator: FilterOperatorTypes.equals,
      value: uniqueGroupIds,
      field: "departmentGroup",
    };
    newFilters.push(filter2);
  }
  else if (session && session?.input_group_id) {
    let mappedGroupId = session?.input_group_id.toString();
    let groupTypeInp = multiDepartmentMappingMltoMB.filter(e => e.filterType == mltombfiltertypes.INPUTGROUP);
    let i = groupTypeInp.findIndex(l => l.mlDepartmentIds.some(k => k === session?.input_group_id));
    if (i != -1) {
      mappedGroupId = groupTypeInp[i].mbDepartmentId.toString();
    }
    let filter1 = {
      operator: FilterOperatorTypes.equals,
      value: [mappedGroupId],
      field: "inputGroup",
    };
    newFilters.push(filter1);
  }
  // else if(cuesheet_header && (cuesheet_header?.input_group_id || cuesheet_header?.producer_id)){
  //   let filter1 = null;
  //   let filter2 = null;
  //   if(session?.input_group_departments && Array.isArray(session?.input_group_departments) && session?.input_group_departments.length > 0){
  //     filter1 = {
  //       operator: FilterOperatorTypes.equals,
  //       value: session.input_group_departments.map( d=> `${cuesheet_header?.input_group_id}-${d}`),
  //       field: "userGroup",
  //     };

  //     if(cuesheet_header?.producer_id){
  //       filter2 = {
  //         operator: FilterOperatorTypes.contains,
  //         value: [cuesheet_header?.producer_id],
  //         field: "productionCompany",
  //       };
  //     }

  //   }
  //   else{
  //     if(cuesheet_header?.input_group_id){
  //       filter1 = {
  //         operator: FilterOperatorTypes.startsWith,
  //         value: [cuesheet_header?.input_group_id],
  //         field: "userGroup",
  //       };
  //     }

  //     if(cuesheet_header?.producer_id){
  //       filter2 = {
  //         operator: FilterOperatorTypes.equals,
  //         value: [cuesheet_header?.producer_id],
  //         field: "productionCompany",
  //       };
  //     }

  //   }
  //   if(filter1){
  //     newFilters.push(filter1);
  //   }
  //   if(filter2){
  //     newFilters.push(filter2);
  //   }
  // }



  if (cuesheet_header && cuesheet_header?.programme_type == standardProgrammeType.Promo) {
    let f = {
      operator: FilterOperatorTypes.equals,
      value: [programmeAndFormType.PROMO],
      field: "cfProgrammeAndFormType",
    };
    newFilters.push(f);

  }

  query.filters = newFilters;
  dispatch({
    type: actionTypes.LOADING,
  });

  axios
    .post(`/cuesheet/search`, query, {
      headers: {
        tid: tId,
        sessionid: sId ? sId : localStorage.getItem('sm_session_id')
      },
    })
    .then((result) => {
      if (result.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD,
          payload: result.data.results,
          total: result.data.total,
          totalRelation: result.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
      if (done) done(result)
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: error },
      });
    });
  // =====

}

export const search = (query, history, sId, done = null) => (dispatch) => {

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });

  const {
    cueSheet: {
      session,
      cueSheet
    }
  } = store.getState();
  if (cueSheet && Object.keys(cueSheet).length > 0) {
    dispatch(cfSearch(query, history, sId, tId, null, done));
  }
  else {
    axios
      .post("/cuesheet/getCueSheet", query, {
        headers: {
          tid: tId,
          sessionid: sId ? sId : localStorage.getItem('sm_session_id')
        },
      })
      .then((res) => {
        if (res.data) {
          dispatch({
            type: actionTypes.SET_CUESHEET,
            // payload: res.data[0],
            payload: res.data.cuesheet_header,
          });

          if (res.data.clearance_form_id != "") {
            history.replace(`/cuesheetCfContent/${res.data.cuesheet_header.cuesheet_id}/${res.data.clearance_form_id}`);
          }
          dispatch(cfSearch(query, history, sId, tId, res.data.cuesheet_header, done));

        }
        else {
          dispatch({
            type: actionTypes.LOAD,
            payload: [],
            total: 0,
            postUpdating: false,
            totalRelation: pagingTotalRelation.EQUALS,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ERROR,
          payload: { e: err },
        });
      });
  }
};
export const getSession = (query, history, done = null) => (dispatch) => {

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });
  axios
    .post("/cuesheet/getSession", query, {
      headers: {
        tid: tId,
        sessionid: query.sessionId
      },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        if (res.data) {
          dispatch({
            type: actionTypes.SET_SESSION,
            payload: { ...res.data.session, sessionId: query.sessionId }
          });
          if (done) done(res.data);
        }
        else {
          dispatch({
            type: actionTypes.LOAD,
            payload: [],
            total: 0,
            postUpdating: false,
            totalRelation: pagingTotalRelation.EQUALS,
          });
        }
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
    });
};
